import { useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import { getEmailDetailsApi, resendEmailApi } from "../apis";
import { errorMessage, successMessage } from "../../../utils";
import React from "react";

export const useEmailLogDetails = () => {
  const { emailLogId } = useParams();
  const [state, setState] = useImmer({
    emailDetails: {
      id: null,
      mail_class: null,
      mailer: null,
      subject: null,
      from: [],
      reply_to: [],
      to_recipient: [],
      cc: [],
      bcc: [],
      sent_at: null,
      html_body: null,
      text_body: null,
      status: null,
    },
    resendButtonLoading: false,
    isLoading: true,
  });

  const breadcrumbs = [
    { name: "Dashboard", href: "/" },
    { name: "Email Log", href: "/email-log" },
    { name: state.emailDetails?.subject ?? "" },
  ];

  // ================================================================ API SECTION ======================================================
  const getEmailDetails = async (id) => {
    triggerDetailsLoading(true);
    try {
      const response = await getEmailDetailsApi(id);
      const { success, message, data } = response;
      if (success) {
        setState((draft) => {
          draft.emailDetails = { ...draft.emailDetails, ...data };
        });
      } else {
        errorMessage(message);
      }
    } catch (error) {
    } finally {
      triggerDetailsLoading(false);
    }
  };

  const resendEmail = async (emailLogId) => {
    setResendButtonLoading(emailLogId);
    try {
      const response = await resendEmailApi(emailLogId);
      const { success, message } = response;
      if (success) {
        successMessage(message);
      } else {
        errorMessage(message);
      }
    } catch (error) {
      const message =
        error.response?.data?.message ?? "Failed to resend the email";
      errorMessage(message);
    } finally {
      setResendButtonLoading(null);
    }
  };

  //   ============================================================== UTIL FUNCTIONS ==============================================================
  const triggerDetailsLoading = (isLoading) => {
    setState((draft) => {
      draft.isLoading = isLoading;
    });
  };

  const setResendButtonLoading = (isLoading) => {
    setState((draft) => {
      draft.resendButtonLoading = isLoading;
    });
  };

  const handleResendEmail = async (emailLogId) => await resendEmail(emailLogId);

  //   ============================================================== USE EFFECT ==============================================================
  React.useEffect(() => {
    getEmailDetails(emailLogId);
  }, []);
  return { state, breadcrumbs, handleResendEmail };
};
